import React from 'react';

const SvgClose = props => (
  <svg
    width={13}
    height={13}
    viewBox="0 0 13 13"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M6.157 5.45L11.46.146a.5.5 0 0 1 .707.708L6.864 6.157l5.303 5.303a.5.5 0 0 1-.707.707L6.157 6.864.854 12.167a.5.5 0 1 1-.708-.707L5.45 6.157.146.854A.5.5 0 1 1 .854.146L6.157 5.45z"
      fill="#046FE2"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgClose;
